import { Component, OnInit, AfterContentInit, Input, Output, EventEmitter, TRANSLATIONS_FORMAT } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, FormArray, AbstractControl, ValidatorFn } from '@angular/forms';
import { NgxPermissionsService } from 'ngx-permissions';
import { EmailSettingsModel } from '@models/emailSettings.model'
import { emptyEmailReminderModel } from '@utilities/data-utils'
import { ReminderEmailModel } from '@models/index';
import { daysForRemindersOpt } from '@utilities/data-utils'
import * as EmailValidator from 'email-validator';
import deepEqual from 'deep-equal'

@Component({
  selector: 'app-email-form',
  templateUrl: './email-form.component.html',
  styleUrls: ['./email-form.component.sass']
})

export class EmailFormComponent implements OnInit, AfterContentInit {
  @Input() emailSettings: EmailSettingsModel;
  @Input() emailEnabled: boolean;
  @Input() numberOfReminders: number;
  @Output() onCancel = new EventEmitter();
  @Output() onSave = new EventEmitter<EmailSettingsModel>();
  @Output() onSendTest = new EventEmitter();

  emailSettingsForm: FormGroup;
  emailTest: string = '';
  undoDisable: boolean = true;
  saveDisable: boolean = true;
  sendTestDisable: boolean = true;
  selectedTabIndex: number = 0;
  emptyReminder: ReminderEmailModel = emptyEmailReminderModel();
  emails: FormArray;
  numberOfEmails: number = 1;
  permissions: any;
  toolbarOptions: string[]

  constructor(
    private fb: FormBuilder,
    private permissionsService: NgxPermissionsService
  ) { }

  ngOnInit() {
    this.permissions = this.permissionsService.getPermissions();
    this.emailSettingsForm = this.fb.group({
      // emails: this.fb.array([{...this.emailSettings.reviewRequest, showWyswyg: false},...this.emailSettings.reminders.map(item=>({...item, showWyswyg: false}))].map(item=>this.fb.group(item)))
      emails: this.buildArray()
    })
    this.formChanged();
    this.emails = this.emailSettingsForm.get('emails') as FormArray;
    this.numberOfEmails = this.emails.length;
  }

  buildArray(){
    let temporal: FormArray = this.fb.array([], this.emailsValidation());
    temporal.push(this.addFormGroup(this.emailSettings.reviewRequest))
    this.emailSettings.reminders.forEach((item)=>temporal.push(this.addFormGroup(item)))
    return temporal;
  }

  addFormGroup(email:any): FormGroup {
    return this.fb.group({
      label: [email.label, this.ValidateLabel],
      subject: [email.subject, this.ValidateSubject],
      header: [email.header, this.ValidateHeader],
      wysiwyg: [email.wysiwyg],
      previewImage: [email.previewImage],
      daysForReminder: [email.daysForReminder],
      minDaysForReminder: [email.minDaysForReminder],
      showWyswyg: false
    })
  }

  formChanged() {
    this.emailSettingsForm.valueChanges.subscribe(val => {
      this.allowUndo();
      this.allowSave();
      this.allowSendTest();
    })
  }

  ngAfterContentInit() {
    this.toolbarOptions = ['size', 'font', 'colorFnt', 'colorBg', 'bold', 'italic', 'underline', 'orderer', 'unorderer', 'align', 'link', 'code', 'reset']
    setTimeout(()=>{
      this.emails = this.emailSettingsForm.get('emails') as FormArray;
      this.emails.at(0).patchValue({
        showWyswyg: true
      })
    },100)
  }

  allowUndo() {
    this.emails = this.emailSettingsForm.get('emails') as FormArray;
    
    let tempEmails = {...{}, emails:[...this.emails.value]}

    tempEmails.emails = tempEmails.emails.map((item) => {
      const newObj = {...item}
      delete newObj.showWyswyg;
      return newObj
    })

    
    this.undoDisable = deepEqual({...{}, emails: [this.emailSettings.reviewRequest, ...this.emailSettings.reminders]},tempEmails);
  }

  allowSave() {

    this.emails = this.emailSettingsForm.get('emails') as FormArray;
    
    let tempEmails = {...{}, emails:[...this.emails.value]}

    tempEmails.emails = tempEmails.emails.map((item) => {
      const newObj = {...item}
      delete newObj.showWyswyg;
      return newObj
    })

    this.saveDisable = !this.emailSettingsForm.valid  || deepEqual({...{}, emails: [this.emailSettings.reviewRequest, ...this.emailSettings.reminders]},tempEmails);
  }

  allowSendTest() {
    this.emails = this.emailSettingsForm.get('emails') as FormArray;
    this.sendTestDisable = (((this.emails.controls[this.selectedTabIndex].get('subject').value.trim().length > 0 ? false : true)
      || (this.emails.controls[this.selectedTabIndex].get('header').value.trim().length > 0 ? false : true)
      || (this.emailTest ? !EmailValidator.validate(this.emailTest) : true)))
  }

  emailsValidation(): ValidatorFn{
    const validator: ValidatorFn = (formArray: FormArray) => {

      let daysForReminder: number[] = [];

      for(let i = 0; i < formArray.length; i++){
        if(i) daysForReminder.push(formArray.controls[i].get('daysForReminder').value)
      }
      return (daysForReminder.length ? (daysForReminder.filter((days) => days == null ? true : false).length > 0 ? false : true ) : true)
      && (daysForReminder.length ? (daysForReminder.reduce((acc,days,index) =>  index ? acc && (days > daysForReminder[index-1]) : true, true)) ? true : false : true)
      ? null : {invalidDays: true};
   };
   return validator;
  }

  undo() {
    this.selectedTabIndex = 0;

    this.emails = this.emailSettingsForm.get('emails') as FormArray;

    this.emails.controls.splice(0)
    
    this.emails.push(this.fb.group({...this.emailSettings.reviewRequest, showWyswyg: false}))
    for(let i=0; i < this.emailSettings.reminders.length; i++){
      this.emails.push(this.fb.group({...this.emailSettings.reminders[i], showWyswyg: false}))
    }

    if(this.selectedTabIndex == 0)
      this.emails.controls[0].get('showWyswyg').setValue(true)

    this.numberOfEmails = this.emails.length;
  }

  save() {
    this.onSave.emit({
      ...{ }, 
      reviewRequest: this.emailSettingsForm.get('emails').value[0],
      reminders: [...this.emailSettingsForm.get('emails').value].slice(1,this.emailSettingsForm.get('emails').value.length)
    })
  }

  sendTest() {
    this.onSendTest.emit({
      ...{ },
      email: this.emailSettingsForm.get('emails').value[this.selectedTabIndex],
      emailTest: this.emailTest
    })
    this.emailTest = ''
  }

  onTab(selectedIndex) {
    setTimeout(()=>{
      this.emails = this.emailSettingsForm.get('emails') as FormArray;
  
      this.emails.at(selectedIndex).patchValue({
        showWyswyg: true
      })
    },100)
    this.selectedTabIndex = selectedIndex;
    this.allowSendTest();
  }

  addReminder() {
    this.emails = this.emailSettingsForm.get('emails') as FormArray;
    this.emails.push(this.fb.group({
        ...{},
        label: [`Reminder ${this.emails.length}`, this.ValidateLabel],
        subject: [this.emptyReminder.subject, this.ValidateSubject],
        header: [this.emptyReminder.header, this.ValidateHeader],
        wysiwyg: this.emptyReminder.wysiwyg,
        daysForReminder: this.emails.length < 11 ?  daysForRemindersOpt[this.emails.length - 1] : daysForRemindersOpt[daysForRemindersOpt.length - 1],
        previewImage: this.emptyReminder.previewImage,
        minDaysForReminder: this.emails.length > 1 ?  this.emails.controls[this.emails.length-1].get('daysForReminder').value : this.emptyReminder.daysForReminder,
        showWyswyg: false
      }
    ))
    this.numberOfEmails = this.emails.length;
    this.selectedTabIndex =  this.emails.length - 1;
  }

  deleteReminder() {
    const deletedTab = this.selectedTabIndex;
    this.selectedTabIndex = 0;
    this.emails = this.emailSettingsForm.get('emails') as FormArray;
    this.emails.removeAt(deletedTab);
    
    for(let i = 1; i < this.emails.length; i++){
      this.emails.controls[i].get('label').setValue(`Reminder ${i}`)
    }

    this.numberOfEmails = this.emails.length;
  }

  getSubject(i) {
    return this.getControls()[i].value.subject;
  }

  getHeader(i) {
    return this.getControls()[i].value.header;
  }

  getLabel(i) {
    return this.getControls()[i].value.label;
  }

  getShowWyswyg(i) {
    return this.getControls()[i].value.showWyswyg;
  }

  getMinDaysForReminder(i) {
    return this.getControls()[i].value.minDaysForReminder;
  }

  getDaysForReminder(i) {
    return this.getControls()[i].value.daysForReminder;
  }
  getControls() {
    return (<FormArray>this.emailSettingsForm.get('emails')).controls;
  }

  ValidateLabel(control: AbstractControl) {
    if(control.value && control.value.trim().length){
      return null;
    }
    return {invalid: true};
  }

  ValidateSubject(control: AbstractControl) {
    if(control.value && control.value.trim().length){
      return null;
    }
    return {invalid: true};
  }

  ValidateHeader(control: AbstractControl) {
    if(control.value && control.value.trim().length){
      return null;
    }
    return {invalid: true};
  }

  getSubjectControl(i) {
    return this.getControls()[i].get('subject');
  }

  getHeaderControl(i) {
    return this.getControls()[i].get('header');
  }

}
